
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

// Lazy load components
const HomePage = lazy(() => import('../pages/home/page'));
const LoginPage = lazy(() => import('../pages/auth/login/page'));
const RegisterPage = lazy(() => import('../pages/auth/register/page'));
const Dashboard = lazy(() => import('../pages/dashboard/page'));
const PersonnelPage = lazy(() => import('../pages/personnel/page'));
const DepartmentsPage = lazy(() => import('../pages/departments/page'));
const UnitsPage = lazy(() => import('../pages/units/page'));
const PositionsPage = lazy(() => import('../pages/positions/page'));
const EmployeesPage = lazy(() => import('../pages/employees/page'));
const HealthExamsPage = lazy(() => import('../pages/health-exams/page'));
const AccidentsPage = lazy(() => import('../pages/accidents/page'));
const AnalyticsPage = lazy(() => import('../pages/analytics/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

// Medical Module Pages
const WaistCircumferencePage = lazy(() => import('../pages/medical/waist-circumference/page'));
const BMIPage = lazy(() => import('../pages/medical/bmi/page'));
const BloodPressurePage = lazy(() => import('../pages/medical/blood-pressure/page'));

// Workplace Module Pages
const NoisePage = lazy(() => import('../pages/workplace/noise/page'));
const DustPage = lazy(() => import('../pages/workplace/dust/page'));
const ChemicalPage = lazy(() => import('../pages/workplace/chemical/page'));

// Lifestyle Module Pages
const SmokingPage = lazy(() => import('../pages/lifestyle/smoking/page'));
const AlcoholPage = lazy(() => import('../pages/lifestyle/alcohol/page'));
const PhysicalActivityPage = lazy(() => import('../pages/lifestyle/physical-activity/page'));

// Health History Module Pages
const FamilyHistoryPage = lazy(() => import('../pages/health-history/family-history/page'));
const AbsenteeismPage = lazy(() => import('../pages/health-history/absenteeism/page'));

// Psychosocial Module Pages
const COPSOQPage = lazy(() => import('../pages/psychosocial/copsoq/page'));
const SCL90Page = lazy(() => import('../pages/psychosocial/scl-90/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/register',
    element: <RegisterPage />
  },
  {
    path: '/dashboard',
    element: <Dashboard />
  },
  // Organization Management Routes
  {
    path: '/departments',
    element: <DepartmentsPage />
  },
  {
    path: '/units',
    element: <UnitsPage />
  },
  {
    path: '/positions',
    element: <PositionsPage />
  },
  {
    path: '/personnel',
    element: <PersonnelPage />
  },
  {
    path: '/employees',
    element: <EmployeesPage />
  },
  {
    path: '/health-exams',
    element: <HealthExamsPage />
  },
  {
    path: '/accidents',
    element: <AccidentsPage />
  },
  {
    path: '/analytics',
    element: <AnalyticsPage />
  },
  // Medical Module Routes
  {
    path: '/medical/waist-circumference',
    element: <WaistCircumferencePage />
  },
  {
    path: '/medical/bmi',
    element: <BMIPage />
  },
  {
    path: '/medical/blood-pressure',
    element: <BloodPressurePage />
  },
  // Workplace Module Routes
  {
    path: '/workplace/noise',
    element: <NoisePage />
  },
  {
    path: '/workplace/dust',
    element: <DustPage />
  },
  {
    path: '/workplace/chemical',
    element: <ChemicalPage />
  },
  // Lifestyle Module Routes
  {
    path: '/lifestyle/smoking',
    element: <SmokingPage />
  },
  {
    path: '/lifestyle/alcohol',
    element: <AlcoholPage />
  },
  {
    path: '/lifestyle/physical-activity',
    element: <PhysicalActivityPage />
  },
  // Health History Module Routes
  {
    path: '/health-history/family-history',
    element: <FamilyHistoryPage />
  },
  {
    path: '/health-history/absenteeism',
    element: <AbsenteeismPage />
  },
  // Psychosocial Module Routes
  {
    path: '/psychosocial/copsoq',
    element: <COPSOQPage />
  },
  {
    path: '/psychosocial/scl-90',
    element: <SCL90Page />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
